export const AppRole = {
    Administrator: "Administrator",
    User: "User",
    Brand: "Brand",
    Retailer: "Retailer"
};
